import { useSystemStatusContext } from '../contexts/SystemStatusContext';
import { isBetaExperienceActive } from './BetaWelcomeModal';
import '../styles/system-status.css';

function openBetaFeedback() {
  window.dispatchEvent(new CustomEvent('wt-open-beta-feedback'));
}

export default function BetaSettingsSection() {
  const { status } = useSystemStatusContext();

  if (!isBetaExperienceActive(status)) return null;

  const knownIssues = status?.beta.knownIssues ?? [];

  return (
    <div className="beta-settings-section">
      <h3>Bêta-test</h3>
      <p className="beta-settings-intro">
        Vous participez à la phase de test. Vos retours nous aident à stabiliser Neo avant l&apos;ouverture
        plus large.
      </p>

      <button type="button" className="settings-action-btn" onClick={openBetaFeedback}>
        Signaler un bug ou une idée
      </button>

      {knownIssues.length > 0 && (
        <div className="beta-settings-known">
          <h4>Problèmes connus</h4>
          <ul>
            {knownIssues.map(issue => (
              <li key={issue}>{issue}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
